export default {
    seguromovil: 'seguromovil',
    seguromultidispositivo: 'seguromultidispositivo',
    seguroportatil: 'seguroportatil'
}